import React from 'react'
import styled, { css } from 'styled-components'
import { H1, Subtitle } from 'components/styled/typography'

interface MediumheaderContentProps {
  title?: string
  status?: string | React.ReactNode
  companyName?: string
  description?: string
}

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  ${({ theme }) => theme.mediaQuery.tablet} {
    flex-grow: 1;
  }
`

const StyledSubtitle = styled(Subtitle)`
  margin-top: ${({ theme }) => theme.space.s12};
  ${({ theme }) => theme.mediaQuery.phone} {
    font-size: 14px;
    padding-top: 0;
    margin-bottom: 0;
  }
`

const LargeHeaderTextStyle = css`
  font-size: ${({ theme }) => theme.space.s40} !important;
  line-height: ${({ theme }) => theme.space.s48} !important;

  ${({ theme }) => theme.mediaQuery.screenS} {
    font-size: ${({ theme }) => theme.space.s32} !important;
    line-height: ${({ theme }) => theme.space.s40} !important;
  }

  ${({ theme }) => theme.mediaQuery.tablet} {
    font-size: ${({ theme }) => theme.space.s24} !important;
    line-height: ${({ theme }) => theme.space.s32} !important;
  }

  ${({ theme }) => theme.mediaQuery.smallPhone} {
    font-size: ${({ theme }) => theme.space.s20} !important;
    line-height: ${({ theme }) => theme.space.s32} !important;
  }
`

const StyledHeaderText = styled(H1)<{ $headerTextLength: number }>`
  ${({ $headerTextLength }) => $headerTextLength >= 70 && LargeHeaderTextStyle};
`
export const MediumHeaderContent = ({
  title = '',
  description,
  companyName,
  status,
}: MediumheaderContentProps) => (
  <HeaderWrapper>
    <div title={title}>
      <StyledHeaderText
        $headerTextLength={title ? title.length : 0}
        textAlign="center"
      >
        {title}
      </StyledHeaderText>
    </div>
    <div>
      {description && (
        <StyledSubtitle
          ellipsis
          color="headerText"
          textAlign="center"
          fontWeight={400}
          numberOfLines={1}
          mb="s12"
          mt="s8"
        >
          {description}
        </StyledSubtitle>
      )}
      {companyName && (
        <StyledSubtitle
          ellipsis
          color="headerText"
          textAlign="center"
          fontWeight={400}
          numberOfLines={1}
          mb="s12"
          mt="s8"
        >
          {companyName}
        </StyledSubtitle>
      )}
      {status && (
        <StyledSubtitle color="white" textAlign="center">
          {status}
        </StyledSubtitle>
      )}
    </div>
  </HeaderWrapper>
)
